var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFolderBlue = function SvgFolderBlue(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8337 11.0833C12.8337 11.3928 12.7107 11.6895 12.492 11.9083C12.2732 12.1271 11.9764 12.25 11.667 12.25H2.33366C2.02424 12.25 1.72749 12.1271 1.5087 11.9083C1.28991 11.6895 1.16699 11.3928 1.16699 11.0833V2.91667C1.16699 2.60725 1.28991 2.3105 1.5087 2.09171C1.72749 1.87292 2.02424 1.75 2.33366 1.75H5.25033L6.41699 3.5H11.667C11.9764 3.5 12.2732 3.62292 12.492 3.84171C12.7107 4.0605 12.8337 4.35725 12.8337 4.66667V11.0833Z",
    stroke: "#6280DA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFolderBlue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/folder-blue.d50f1185.svg";
export { ForwardRef as ReactComponent };